import Axios from 'axios'
import React, {useState} from 'react'
import {useEffect} from 'react'
import {Link} from 'react-router-dom'

import styles from './Galery.module.css'

import {API_URL} from '../../ApiUrl.js'
import CardGroup from 'reactstrap/lib/CardGroup'
import Card from 'reactstrap/lib/Card'
import sculptures from '../img/sculptures.jpeg'
import peintures from '../img/peintures.jpeg'

function Galery() {
  const [arts, setArts] = useState([])
  const [error, setError] = useState('')

  const getArts = async () => {
    try {
      const res = await Axios.get(`${API_URL}/api/sculptures`)
      const array = res.data
        .sort((b, a) => a.Type.label.localeCompare(b.Type.label))
        .reduce((acc, current) => {
          const type = acc.find((item) => item.Type.id === current.Type.id)
          return !type ? acc.concat([current]) : acc
        }, [])
      setArts(array)
    } catch (err) {
      setError('Erreur de chargement')
    }
  }

  useEffect(() => {
    getArts()
  }, [])
  
  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

   return (
    <div className={styles.galeryStyle}>
      {error && <p className="text-danger text-center">{error}</p>}
      
      <h1 className="title-centered-white text-center">Galerie</h1>
      
      <div className="row-flex-spaced">
        <CardGroup className={styles.cardGroup}>
          {arts.map((item) => {
            // Sélection de l'image intelligente
            let imgSource = item.imageUrl;
            if (item.Type.label === 'Sculptures') imgSource = sculptures;
            if (item.Type.label === 'Peintures') imgSource = peintures;

            return (
              <div key={item.id} className={styles.cardSizeType}>
                <Link to={`/galery/${item.Type.id}`} className="text-decoration-none" onClick= {handleScrollToTop}>
                  <img
                    className={styles.imageType}
                    src={imgSource}
                    alt={item.Type.label}
                  />
                <h3 className={styles.h3Card}>{item.Type.label}</h3>
                </Link>
              </div>
            )
          })}
        </CardGroup>
      </div>
    </div>
  )
}
export default Galery
